import { useState, useEffect } from "react";

// Custom hook that detects if the screen width exceeds 3800px and updates dynamically on window resize.

const useLargeScreen = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 3800);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 3800);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isLargeScreen;
};

export default useLargeScreen;
